import axios from 'axios';

const checkIsin = (isin: string) => {
    return axios({
        method: 'GET',
        url: window.location.origin + `/isbpublicjson/api/Issue?lang=cz&isin=${isin}`
    }).then(resp =>
        axios({
            method: 'GET',
            url: window.location.origin + `/isbpublicjson/api/Issue/${resp.data.idrecemr}?lang=cz`
        }).then(data => data.data)
    );
};

export default checkIsin;
